//  Convert a "dd/MM/yyyy" string into "MM/dd/yyyy" string
export const convertToCompatibleDateString = (dateString: string) => {
  return dateString.replace(/(\d+[/])(\d+[/])/, "$2$1");
};
